import { useIntl } from 'react-intl'
import { Tag } from 'primereact/tag'
import { UrgencyWhereRowDTO } from '../../../dto/urgencySummary/UrgencySummaryDTO'
import { LEVEL_LABEL_ID, LEVEL_TAG_CLASS, RANKING_LEVEL } from '../../ServicesStatistics/waitLevelText'
import { formatMinutes } from '../urgencySummaryFormat'
import UrgencyWaitCauses from './UrgencyWaitCauses'

interface UrgencyDayCausesProps {
  rows: UrgencyWhereRowDTO[]
  /** Hay una guardia elegida: su nombre ya está en los filtros y no se repite en cada bloque. */
  single: boolean
}

/**
 * «Posibles causas» del día: una guardia por bloque, con su espera y su nivel (con texto) y las causas que encuentra el
 * backend ese día. Solo van las guardias que superaron algún umbral (con nivel de atención o crítico, o con alguna causa); si
 * ninguna lo hizo, lo dice. Son hipótesis a partir de los datos, no un diagnóstico.
 */
export default function UrgencyDayCauses({ rows, single }: UrgencyDayCausesProps) {
  const intl = useIntl()
  const flagged = rows.filter((row) => row.arrivals > 0 && (row.level !== 'OK' || row.causes.length > 0))

  if (flagged.length === 0) {
    return (
      <p className="nv-note">
        <i className="pi pi-info-circle" aria-hidden="true" />
        {intl.formatMessage({ id: 'UrgencySummaryDayCausesEmpty' })}
      </p>
    )
  }
  return (
    <ul className="nv-urg-detail__causes">
      {flagged.map((row) => {
        const level = RANKING_LEVEL[row.level]
        return (
          <li key={row.templateId} className="nv-urg-detail__cause">
            <div className="nv-urg-detail__cause-head">
              {!single && <span className="nv-urg-detail__name">{row.templateName}</span>}
              <span className="nv-urg-detail__cause-wait">
                <span className="nv-urg-detail__minutes">{formatMinutes(intl, row.avgWaitMinutes)}</span>
                {row.avgWaitMinutes !== null && (
                  <Tag className={LEVEL_TAG_CLASS[level]} value={intl.formatMessage({ id: LEVEL_LABEL_ID[level] })} />
                )}
              </span>
            </div>
            <UrgencyWaitCauses causes={row.causes} level={row.level} />
          </li>
        )
      })}
    </ul>
  )
}
